import actions from './actions';
import reducer from './reducer';

const physicianDetails = {
    actions,
    reducer,
    name: 'physicianDetails',
};

export default physicianDetails;